import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Web2BannerService } from '@services/web2-banner/web2-banner.service';

@Component({
  selector: 'app-web2-banner',
  templateUrl: './web2-banner.component.html',
  styleUrls: ['./web2-banner.component.scss'],
})
export class Web2BannerComponent implements OnInit, OnDestroy {
  isVisible: boolean;
  private visibilitySub: Subscription;

  constructor(
    private web2BannerService: Web2BannerService,
  ) {
    this.isVisible = false;
  }

  ngOnInit() {
    this.visibilitySub = this.web2BannerService.isVisible.subscribe((isVisible: boolean) => {
      this.isVisible = isVisible;
      if (isVisible) {
        this.web2BannerService.logBannerView();
      }
    });
  }

  ngOnDestroy() {
    if (this.visibilitySub) {
      this.visibilitySub.unsubscribe();
    }
  }

  onTryNowClick(): void {
    this.web2BannerService.goToWeb2();
  }
}
